<main id="main-content" class="ds-product-page ds-product-page--narrow verification-page">
  @if (loading()) {
    <ds-state kind="loading" [title]="'verify.loading' | t" />
  } @else if (notFound()) {
    <ds-state kind="error" [title]="'verify.failed' | t" [message]="'verify.help' | t">
      <a dsButton routerLink="/">{{ 'verify.start' | t }}</a>
    </ds-state>
  } @else if (verification(); as record) {
    <section dsCard class="verification-card">
      <div class="verified-banner">
        <ds-badge tone="success">{{ 'verify.verified' | t }}</ds-badge>
        <small>{{ 'verify.details' | t }}</small>
      </div>
      <header class="document-heading">
        <p class="eyebrow">{{ 'iq.assessment' | t }}</p>
        <h1>{{ record.candidateName }}</h1>
        <span
          >{{ 'verify.completed' | t }}
          {{ completedDate(record.completedAtUtc, record.language) }}</span
        >
      </header>
      <div class="score-layout">
        <ds-score-visualization
          [value]="record.result.correct * 2.5"
          [displayValue]="record.result.estimate"
          [label]="'verify.estimate' | t"
        />
        <div class="domains">
          @for (domain of record.result.domains; track domain.domain) {
            <ds-progress
              [value]="domain.correct * 10"
              [label]="
                domainName(domain.domain, record.language) +
                ' ' +
                domain.correct +
                '/' +
                domain.total
              "
            />
          }
        </div>
      </div>
      <dl class="candidate-details">
        <div>
          <dt>{{ 'verify.firstName' | t }}</dt>
          <dd>{{ record.firstName }}</dd>
        </div>
        <div>
          <dt>{{ 'verify.lastName' | t }}</dt>
          <dd>{{ record.lastName }}</dd>
        </div>
        <div>
          <dt>{{ 'verify.dateOfBirth' | t }}</dt>
          <dd>{{ birthDate(record.dateOfBirth) }}</dd>
        </div>
        <div>
          <dt>{{ 'verify.id' | t }}</dt>
          <dd>{{ record.testId }}</dd>
        </div>
        <div>
          <dt>{{ 'common.status' | t }}</dt>
          <dd>
            <ds-badge tone="success">{{ 'common.valid' | t }}</ds-badge>
          </dd>
        </div>
      </dl>
      <ds-alert [title]="'verify.verified' | t"
        ><p>{{ 'verify.disclaimer' | t }}</p></ds-alert
      >
      <div class="actions">
        <a dsButton [href]="certificateUrl(record.testId)">{{ 'verify.download' | t }}</a>
        <a dsButton variant="secondary" routerLink="/">{{ 'verify.new' | t }}</a>
      </div>
    </section>
  }
</main>
